module.exports = __webpack_public_path__ + "img/indexLogo.e26a9e17.png";